import { styled } from '@mui/material/styles';
export const Wrapper = styled('div')`
  display: flex;
`;

export const MainWrapper = styled('main')`
  flex-grow: 1;
  padding: 1.5rem;
`;
